import styles from './license-plate-controller-card.module.sass';
import { ArrowRightCircleIcon } from 'icons';

export const LicensePlateControllerListItem = ({ title, content, onClick }) => {
  return (
    <li className={styles['list-item']} onClick={onClick}>
      <div className={styles['left-section']}>
        <div className={styles['left-section-title']}>{title}</div>
        <div className={styles['left-section-content']}>{content}</div>
      </div>
      <ArrowRightCircleIcon color="#007aff" />
    </li>
  );
};
